module.exports = __webpack_public_path__ + "static/media/e.890c875f.png";